import { Link, useLocation } from "react-router-dom";
import Layout from "../Partials/Layout";
import PageTitle from "../Helpers/PageTitle";
import { ManufacturerTypeId, DropShipperTypeId, SupplierTypeId } from "../../utils";

const roleConfig = {
  [ManufacturerTypeId]: {
    role: "Manufacturer",
    portalUrl: process.env.REACT_APP_SELLER_PORTAL_URL,
    description: "You can now list your manufactured products, manage inventory, and connect with dropshippers and suppliers on the platform.",
  },
  [DropShipperTypeId]: {
    role: "Dropshipper",
    portalUrl: process.env.REACT_APP_BUYER_PORTAL_URL,
    description: "You can now browse products from suppliers, add them to your store, and start fulfilling orders without managing inventory.",
  },
  [SupplierTypeId]: {
    role: "Supplier",
    portalUrl: process.env.REACT_APP_SELLER_PORTAL_URL,
    description: "You can now list your products, manage orders, and connect with dropshippers and manufacturers on the platform.",
  },
};

export default function RegisterSuccess() {
  const { state } = useLocation();
  const planName = state?.planName || "Membership";
  const userType = state?.userType;
  const config = roleConfig[userType] || { role: "Seller", portalUrl: process.env.REACT_APP_SELLER_PORTAL_URL, description: "You can now manage your store and connect with buyers on the platform." };
  const portalUrl = config.portalUrl || "#";

  return (
    <Layout childrenClasses="pt-0 pb-0">
      <div className="w-full">
        <div className="title mb-10">
          <PageTitle
            title="Registration Successful"
            breadcrumb={[
              { name: "home", path: "/" },
              { name: "registration successful", path: "/register-success" },
            ]}
          />
        </div>
        <div className="content-wrapper w-full mb-10">
          <div className="container-x mx-auto">
            <div className="w-full bg-white sm:p-[30px] p-5 flex flex-col items-center">

              {/* Green checkmark */}
              <div
                className="w-20 h-20 rounded-full flex items-center justify-center mb-6"
                style={{ backgroundColor: '#009640' }}
              >
                <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
                  <path d="M8 20L16 28L32 12" stroke="white" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </div>

              {/* Heading */}
              <h2 className="text-2xl font-700 text-qblack mb-2 text-center">
                Welcome aboard, {config.role}!
              </h2>
              <p className="text-qgray text-base text-center mb-2">
                You have registered with the <span className="font-600 text-qblack">{planName}</span> plan.
              </p>
              <p className="text-qgray text-sm text-center mb-2 max-w-lg">
                {config.description}
              </p>
              <p className="text-qgray text-sm text-center mb-8 max-w-lg">
                To start using your account, complete your membership payment via the Seller Panel.
              </p>

              {/* Steps */}
              <div className="w-full max-w-lg mb-10">
                <h3 className="text-base font-700 text-qblack mb-4">Next Steps</h3>
                <div className="flex flex-col space-y-5">
                  <div className="flex items-start space-x-4">
                    <div
                      className="w-8 h-8 rounded-full flex-shrink-0 flex items-center justify-center text-white text-sm font-700"
                      style={{ backgroundColor: '#009640' }}
                    >
                      1
                    </div>
                    <div>
                      <p className="font-600 text-qblack">Login to {config.role} Panel</p>
                      <p className="text-qgray text-sm">Use your registered email and password to sign in to the seller portal.</p>
                    </div>
                  </div>
                  <div className="flex items-start space-x-4">
                    <div
                      className="w-8 h-8 rounded-full flex-shrink-0 flex items-center justify-center text-white text-sm font-700"
                      style={{ backgroundColor: '#009640' }}
                    >
                      2
                    </div>
                    <div>
                      <p className="font-600 text-qblack">Go to Activate Membership</p>
                      <p className="text-qgray text-sm">
                        Navigate to <span className="font-500 text-qblack">Membership Plan → Activate Membership</span> from the sidebar.
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start space-x-4">
                    <div
                      className="w-8 h-8 rounded-full flex-shrink-0 flex items-center justify-center text-white text-sm font-700"
                      style={{ backgroundColor: '#009640' }}
                    >
                      3
                    </div>
                    <div>
                      <p className="font-600 text-qblack">Complete Payment</p>
                      <p className="text-qgray text-sm">
                        Click <span className="font-500 text-qblack">Pay Now</span> to complete your <span className="font-500 text-qblack">{planName}</span> membership payment via PayPro and activate your account.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Action buttons */}
              <div className="flex flex-col sm:flex-row gap-4">
                <a
                  href={portalUrl}
                  className="text-white text-sm font-600 text-center px-8 py-3 rounded hover:opacity-90 transition-opacity"
                  style={{ backgroundColor: '#009640' }}
                >
                  Go to {config.role} Panel
                </a>
                <Link
                  to="/"
                  className="border border-qgray-border text-qblack px-8 py-3 rounded text-sm font-600 text-center hover:border-qblack transition-colors"
                >
                  Back to Home
                </Link>
              </div>

            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}
